import styled from 'styled-components';
import { colors } from 'styles/remoteControlColors';

export const DotComponent = styled.button<{ active: boolean }>`
  margin: 0;
  padding: 0;
  border: none;
  width: 12px;
  height: 12px;
  border-radius: 9999px;
  background-color: ${({ active }) => (active ? colors.Blue700 : colors.Grey300)};

  ${({ active }) => (active ? `
      &:hover {
        background-color: ${colors.BlueDark900};
      }
    ` : 'cursor: pointer;'
  )}
`;

export const DotGroupContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;
